import { lazy } from 'react';

export const ConfirmMailLazy = lazy(() => import('./ConfirmMail'));
